!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define("TextEllipsis", ["React"], e) : "object" == typeof exports ? exports.TextEllipsis = e(require("react")) : t.TextEllipsis = e(t.React);
}("undefined" != typeof self ? self : this, function (t) {
  return function (t) {
    function e(i) {
      if (n[i]) return n[i].exports;
      var r = n[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, e), r.l = !0, r.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.d = function (t, n, i) {
      e.o(t, n) || Object.defineProperty(t, n, {
        configurable: !1,
        enumerable: !0,
        get: i
      });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "/dist/", e(e.s = 0);
  }([function (t, e, n) {
    "use strict";

    function i(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function r(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function o(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }

    function s(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var u = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
        }
      }

      return function (e, n, i) {
        return n && t(e.prototype, n), i && t(e, i), e;
      };
    }(),
        c = n(1),
        a = n(2),
        l = i(a),
        f = n(4),
        p = i(f),
        h = function (t) {
      function e(t) {
        r(this, e);
        var n = o(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
        return n.isSupportNativeClamp = !n.props.useJsOnly && "webkitLineClamp" in document.body.style, n.truncate = n.truncate.bind(n), n.process = n.process.bind(n), n.debounceProcess = (0, l.default)(n.process, n.props.debounceTimeoutOnResize), n;
      }

      return s(e, t), u(e, [{
        key: "componentDidMount",
        value: function value() {
          this.text = this.container.innerHTML, this.process(), window.addEventListener("resize", this.debounceProcess, !1);
        }
      }, {
        key: "componentDidUpdate",
        value: function value() {
          this.text = this.container.innerHTML, this.process();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          window.removeEventListener("resize", this.debounceProcess, !1);
        }
      }, {
        key: "onResult",
        value: function value() {
          this.container.scrollWidth > this.container.clientWidth || this.container.scrollHeight > this.container.clientHeight ? this.props.onResult(e.RESULT.TRUNCATED) : this.props.onResult(e.RESULT.NOT_TRUNCATED);
        }
      }, {
        key: "getLineHeight",
        value: function value() {
          var t = this.computedStyle("line-height");
          return "normal" === t ? Math.ceil(1.2 * parseFloat(this.computedStyle("font-size"))) : Math.ceil(parseFloat(t));
        }
      }, {
        key: "getTextWithEllipsis",
        value: function value(t, e) {
          return this.currentText = this.text.slice(t, e), this.currentText + this.props.ellipsisChars;
        }
      }, {
        key: "truncate",
        value: function value() {
          this.container.offsetHeight > this.lineHeight * this.props.lines ? (this.container.innerHTML = this.getTextWithEllipsis(0, this.end - 1), this.onResult()) : this.end >= this.textLength ? (this.container.innerHTML = this.currentText, this.onResult()) : (this.container.innerHTML = this.getTextWithEllipsis(this.start, ++this.end), this.truncate());
        }
      }, {
        key: "process",
        value: function value() {
          if (this.isSupportNativeClamp) {
            var t = this.container.style;
            t.overflow = "hidden", t.textOverflow = "ellipsis", t.webkitBoxOrient = "vertical", t.display = "-webkit-box", t.webkitLineClamp = this.props.lines, this.container.innerHTML = this.text, this.onResult();
          } else this.textLength = this.text.length, this.currentText = "", this.start = 0, this.end = this.text.length > 0 ? 1 : 0, this.lineHeight = this.getLineHeight(), this.container.innerHTML = "", this.truncate();
        }
      }, {
        key: "computedStyle",
        value: function value(t) {
          return document.defaultView.getComputedStyle(this.container, null).getPropertyValue(t);
        }
      }, {
        key: "render",
        value: function value() {
          var t = this;
          return (0, c.createElement)(this.props.tag, {
            ref: function ref(e) {
              t.container = e;
            },
            className: this.props.tagClass,
            style: Object.assign({
              width: "100%",
              wordWrap: "break-word"
            }, this.props.style)
          }, this.props.children);
        }
      }]), e;
    }(c.Component);

    h.RESULT = {
      TRUNCATED: "TRUNCATED",
      NOT_TRUNCATED: "NOT_TRUNCATED"
    }, h.propTypes = {
      lines: p.default.number.isRequired,
      children: p.default.element.isRequired,
      tag: p.default.string,
      ellipsisChars: p.default.string,
      tagClass: p.default.string,
      debounceTimeoutOnResize: p.default.number,
      useJsOnly: p.default.bool,
      onResult: p.default.func,
      style: p.default.object
    }, h.defaultProps = {
      tag: "div",
      ellipsisChars: "...",
      tagClass: "",
      debounceTimeoutOnResize: 200,
      useJsOnly: !1,
      style: {},
      onResult: function onResult() {}
    }, e.default = h;
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    (function (e) {
      function n(t, e, n) {
        function r(e) {
          var n = y,
              i = b;
          return y = b = void 0, w = e, T = t.apply(i, n);
        }

        function o(t) {
          return w = t, m = setTimeout(l, e), E ? r(t) : T;
        }

        function c(t) {
          var n = t - R,
              i = t - w,
              r = e - n;
          return j ? x(r, v - i) : r;
        }

        function a(t) {
          var n = t - R,
              i = t - w;
          return void 0 === R || n >= e || n < 0 || j && i >= v;
        }

        function l() {
          var t = O();
          if (a(t)) return f(t);
          m = setTimeout(l, c(t));
        }

        function f(t) {
          return m = void 0, _ && y ? r(t) : (y = b = void 0, T);
        }

        function p() {
          void 0 !== m && clearTimeout(m), w = 0, y = R = b = m = void 0;
        }

        function h() {
          return void 0 === m ? T : f(O());
        }

        function d() {
          var t = O(),
              n = a(t);

          if (y = arguments, b = this, R = t, n) {
            if (void 0 === m) return o(R);
            if (j) return m = setTimeout(l, e), r(R);
          }

          return void 0 === m && (m = setTimeout(l, e)), T;
        }

        var y,
            b,
            v,
            T,
            m,
            R,
            w = 0,
            E = !1,
            j = !1,
            _ = !0;

        if ("function" != typeof t) throw new TypeError(u);
        return e = s(e) || 0, i(n) && (E = !!n.leading, j = "maxWait" in n, v = j ? g(s(n.maxWait) || 0, e) : v, _ = "trailing" in n ? !!n.trailing : _), d.cancel = p, d.flush = h, d;
      }

      function i(t) {
        var e = typeof t;
        return !!t && ("object" == e || "function" == e);
      }

      function r(t) {
        return !!t && "object" == typeof t;
      }

      function o(t) {
        return "symbol" == typeof t || r(t) && m.call(t) == a;
      }

      function s(t) {
        if ("number" == typeof t) return t;
        if (o(t)) return c;

        if (i(t)) {
          var e = "function" == typeof t.valueOf ? t.valueOf() : t;
          t = i(e) ? e + "" : e;
        }

        if ("string" != typeof t) return 0 === t ? t : +t;
        t = t.replace(l, "");
        var n = p.test(t);
        return n || h.test(t) ? d(t.slice(2), n ? 2 : 8) : f.test(t) ? c : +t;
      }

      var u = "Expected a function",
          c = NaN,
          a = "[object Symbol]",
          l = /^\s+|\s+$/g,
          f = /^[-+]0x[0-9a-f]+$/i,
          p = /^0b[01]+$/i,
          h = /^0o[0-7]+$/i,
          d = parseInt,
          y = "object" == typeof e && e && e.Object === Object && e,
          b = "object" == typeof self && self && self.Object === Object && self,
          v = y || b || Function("return this")(),
          T = Object.prototype,
          m = T.toString,
          g = Math.max,
          x = Math.min,
          O = function O() {
        return v.Date.now();
      };

      t.exports = n;
    }).call(e, n(3));
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    t.exports = n(5)();
  }, function (t, e, n) {
    "use strict";

    var i = n(6),
        r = n(7),
        o = n(8);

    t.exports = function () {
      function t(t, e, n, i, s, u) {
        u !== o && r(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e
      };
      return n.checkPropTypes = i, n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    "use strict";

    function i(t) {
      return function () {
        return t;
      };
    }

    var r = function r() {};

    r.thatReturns = i, r.thatReturnsFalse = i(!1), r.thatReturnsTrue = i(!0), r.thatReturnsNull = i(null), r.thatReturnsThis = function () {
      return this;
    }, r.thatReturnsArgument = function (t) {
      return t;
    }, t.exports = r;
  }, function (t, e, n) {
    "use strict";

    function i(t, e, n, i, o, s, u, c) {
      if (r(e), !t) {
        var a;
        if (void 0 === e) a = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var l = [n, i, o, s, u, c],
              f = 0;
          a = new Error(e.replace(/%s/g, function () {
            return l[f++];
          })), a.name = "Invariant Violation";
        }
        throw a.framesToPop = 1, a;
      }
    }

    var r = function r(t) {};

    t.exports = i;
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }]);
});